import { CognitoUserSession } from 'amazon-cognito-identity-js';
import { Auth } from 'aws-amplify';
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';

// Try and refresh the token before sending the request.
axios.interceptors.request.use(async (config: AxiosRequestConfig) => {
	if (config.skipAuth) {
		return config;
	}

	try {
		const currentSession = await Auth.currentSession();
		const jwtToken = currentSession.getIdToken().getJwtToken();
		config.headers.Authorization = jwtToken;
	} catch (e) {
		// console.log('error', e);
	}

	return config;
});

// If a 401 Unauthorized response is received, retry the original request a second time with a
// refreshed ID token.
axios.interceptors.response.use(
	undefined,
	async (error: any): Promise<unknown> => {
		try {
			// Extract typed variables from the error.
			const config: AxiosRequestConfig | undefined = error?.config;
			const response: AxiosResponse<unknown> | undefined = error?.response;

			const skipAuth: boolean | undefined = config?.skipAuth;
			const status: number | undefined = response?.status;

			if (skipAuth !== true && status === 401) {
				const currentSession: CognitoUserSession = await Auth.currentSession();
				const jwtToken: string = currentSession.getIdToken().getJwtToken();
				config.headers = {
					...config.headers,
					Authorization: jwtToken,
				};
				return axios(config);
			}
		} catch (secondError) {
			// Squelch the second error in favor of the first.
		}

		// Proceed as usual.
		throw error;
	},
);
